import React from "react";
import { assetBaseUrl } from "@api";

export const Logo = ({ className, merchant, height, type = "center" }) => {
  // Style options
  // left
  // center
  // leftinverted

  let organisationId = merchant?.organisationId;

  if (!organisationId) {
    organisationId = "ontik";
  }

  // Ontik-leftlight
  const imageName = `${organisationId.toLowerCase()}-${type}.png`;

  const url = assetBaseUrl() + imageName;

  // Size by the header's available height (68px bar minus 8px padding top
  // and bottom = 52px) and cap only the width. Square/portrait logos fill the
  // height; wide logos hit the width cap and are letterboxed by object-fit.
  return (
    <img
      className={`${className}`}
      style={{
        height: height ?? "52px",
        width: "auto",
        maxWidth: "240px",
        objectFit: "contain",
        alignSelf: "center",
      }}
      src={url}
      alt="logo"
    />
  );
};
